import { BannerWrap } from 'src/styles/styledcomponent/component/common'
import { useRecoilValue } from 'recoil'
import { PartnerListData } from 'src/recoil/common'
import {getImgServerURL} from "src/service/utils";

const FooterBanner = () => {
  const { FooterImage } = useRecoilValue(PartnerListData)

  return !!FooterImage ? (
    <BannerWrap>
      <img src={`${getImgServerURL()}${FooterImage}`} alt="푸터배너" />
    </BannerWrap>
  ) : null
}
export default FooterBanner
